module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("6")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Pflück")]), _vm._v(" diese kleine\nBlume und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nnimm sie und zögre nicht, ich fürchte, sie"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nwelkt und fällt in den Staub.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Sie wird keinen Platz in deinem Kranze"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nfinden, doch ehre sie mit dem Schmerzensdruck"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndeiner Hand und pflücke sie"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nab. Ich fürchte, der Tag könnt enden, eh"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nich es merke und die Zeit des Opferns"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nvergehn.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ist auch die Farbe nicht tief und ihr"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nDuft nur schwach, nütze die Blume für"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndeinen Dienst und pflück sie, solange es"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nZeit ist. "), _c('a', {
    attrs: {
      "id": "page9",
      "title": "wedi/cal"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5aaef08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0007.vue
// module id = 75
// module chunks = 0